import * as React from 'react';
import { Stack, Typography, TextField, Grid, FormGroup, FormControlLabel, Checkbox } from '@mui/material';

import Service from '../../../util/Service';

// export default function NodeGateway(props) {
const NodeGatewayInclusive = React.forwardRef((props, ref) => {
    const { item, processo } = props;

    const [checked, setChecked] = React.useState(true);


    React.useEffect(() => {
        const i = processo.lstTask.find(t => t.idTask === item.id);
        console.log( i && i.criterio?true:false );
        setChecked( i && i.criterio?true:false );

    }, [processo]);

    React.useImperativeHandle(ref, () => ({
        childMethod() {
            handleComplete();
        }
    }))

    const handleComplete = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            // tipo: tipo,
            taskType: item.type,
            criterio: checked
        }

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log(resp);
        }).catch(error => {
            console.error(error)
        })
    };

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    return (
        <div style={{ width: '100%' }}>
            <Grid container spacing={2} >
                <Grid size={12}>
                    <Typography variant="h6" gutterBottom>
                        Defina critério para fluxo
                    </Typography>
                </Grid>
                {/* <Gridsize={1}>
                <Button onClick={handleComplete}>
                    Salvar
                </Button>
            </Grid> */}
                <Grid size={12}>
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox
                                checked={checked}
                                onChange={handleChange}
                            />
                        } label="Aguardar ate que todos tenham executado" />
                    </FormGroup>
                </Grid>
            </Grid>
        </div>
    )
})

export default NodeGatewayInclusive;